import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { listBreakpoint } from 'shared/constants/styles'

export const Wrapper = styled.div(
  (props: { noMargin?: boolean }) => css`
    display: flex;
    justify-content: space-between;
    margin-top: ${props.noMargin ? '0' : '1em'};

    & > span > button {
      height: 100%;
    }

    @media screen and (max-width: ${listBreakpoint + 'px'}) {
      display: grid;
      justify-content: unset;
      justify-items: center;
      width: 100%;
    }
  `
)

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2em;
`

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;

  & > span:first-of-type {
    margin-right: 1em;
  }

  @media screen and (max-width: ${listBreakpoint + 'px'}) {
    justify-content: space-between;
    width: 100%;
  }
`
